<template>
    <div class="tableBox planReport">
        <p class="title">{{title}}</p>
        <table>
            <tbody>
            <tr>
                 <th rowSpan="2">目标职业</th>
                 <td>{{version==1?'目标职业领域':'目标职业类'}}：{{plan.targetCareerField}}</td>
                 <!-- <td>{{version==1?'目标职业领域':'目标职业类'}}：{{plan.targetCareerField}}</td> -->
            </tr>
            
            <!-- <tr>
                <td>目标职业：
                    <template v-if="plan.targetCareer">
                        <span v-for="(item,index) in plan.targetCareer" :key="index">
                            <template v-if="index>0">、</template>
                            {{item}}
                    </span>
                    </template>
                </td>
            </tr> -->
            <tr>
                <td>目标职业：
                    <template >
                        <span v-for="(item,index) in plan.targetCareer" :key="index">
                            <template v-if="index>0">、</template>
                            {{item}}
                    </span>
                    </template>
                </td>
            </tr>
             <!-- <tr>
                <th :rowspan="2">目标专业</th>
                <td>目标专业类：{{plan.professional}}</td>
            </tr>
            <tr>
                <td>目标专业：
                    <template v-if="plan.targetSubject">
                        <span v-for="(item,index) in plan.targetSubject" :key="index">
                            <template v-if="index>0">、</template>
                            {{item}}
                        </span>
                    </template>
                </td>
            </tr> -->
             <tr>
                <th :rowspan="2">目标专业</th>
                <td v-if="version==2||version==0">目标专业类：{{plan.professional=='null'?'':plan.professional}}</td>
            </tr>
            <tr>
                <td>目标专业：
                    <template v-if="plan.targetSubject">
                        <span v-for="(item,index) in plan.targetSubject" :key="index">
                            <template v-if="index>0">、</template>
                            {{item}}
                        </span>
                    </template>
                </td>
            </tr>
            <tr>
                <th>目标院校</th>
                <td>
                    <template v-if="plan.universityIdName">
                        <span v-for="(item,index) in plan.universityIdName" :key="index">
                            <template v-if="index>0">、</template>
                            {{item.name}}
                        </span>
                    </template>
                </td>
            </tr>
            <tr>
                <th>目标分数</th>
                <td>
                    {{plan.score}} / {{plan.rank}}
                </td>
            </tr>
            <tr>
                <th rowspan="3" >目标路径</th>
                <td>升学路径：{{plan.furtherWay}}</td>
            </tr>
            <tr>
                <td>路径条件：{{plan.furtherWayNeed}}</td>
            </tr>
            <tr>
                <td>其他条件：{{plan.furtherWayNeedOther}}</td>
            </tr>
            <tr>
                <th>目标选科</th>
                <td>
                    <template v-if="plan.chooseSubjectName">
                        <span v-for="(item,index) in plan.chooseSubjectName" :key="index">
                            <template v-if="index>0">、</template>
                            {{item}}
                        </span>
                    </template>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    name: "planReport",
    props: ['title', 'plan','version'],
    components: {
    },
    data() {
        return {
        }
    },
    created(){
console.log(this.version)
    },
    mounted(){
        console.log(this.version)
    }
}
</script>
<style scoped lang="less">
.tableBox {
    background-color: #fff;
    margin-bottom: 55px;
    .title {
        font-size: 28px;
        font-weight: 500;
        color: #3D90F6;
        line-height: 30px;
        margin-bottom: 20px;
    }
    table {
        width: 100%;
        tbody {
            font-size: 16px;
            tr {
                line-height: 40px;
                th {
                    font-weight: bold;
                    text-align: center;
                    font-size: 16px;
                    width: 148px;
                    border: 1px solid #3D90F6;
                    background: rgba(61, 144, 246, 0.1);
                }
                td {
                    font-size: 14px;
                    padding-left: 40px;
                    border: 1px solid #3D90F6;
                }
            }
        }
    }
}
</style>